import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.953 12.508c0-1.8 1.512-2.493 4.016-2.493 3.59 0 8.125 1.062 11.716 2.954V2.123C23.764.6 19.89 0 15.969 0 6.378 0 0 4.892 0 13.062c0 12.738 17.953 10.707 17.953 16.2 0 2.123-1.89 2.815-4.536 2.815-3.92 0-8.929-1.57-12.897-3.692v10.984C4.913 41.215 9.354 42 13.417 42 23.244 42 30 37.246 30 28.985c-.047-13.754-18.047-11.308-18.047-16.477"
    }, null, -1)
  ])))
}
export default { render: render }